import React from 'react';
import { Helmet } from 'react-helmet';
import { Provider } from 'mobx-react';


import { FetchCacheStore } from 'modules/with-fetch';
import { LogPageView } from 'modules/ga';

import Main from 'layout/main/Main';

const App = () => (
  <Provider fetchCacheStore={FetchCacheStore}>
    <div className="app">
      <LogPageView />
      <Helmet>
        <meta charSet="utf-8" />
        <title>My NF Coaching</title>
        <meta httpEquiv="cache-control" content="max-age=0" />
        <meta httpEquiv="cache-control" content="no-cache" />
        <meta httpEquiv="expires" content="0" />
        <meta httpEquiv="expires" content="Tue, 01 Jan 1980 1:00:00 GMT" />
        <meta httpEquiv="pragma" content="no-cache" />
      </Helmet>
      <Main />
    </div>
  </Provider>
);

export default App;
